import React from "react";
import { faSpinner } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
var Loading = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "medium" : _b, _c = _a.variant, variant = _c === void 0 ? "spinner" : _c, text = _a.text, _d = _a.inline, inline = _d === void 0 ? false : _d, _e = _a.className, className = _e === void 0 ? "" : _e, color = _a.color;
    var baseClasses = "lib-loading";
    var sizeClass = "lib-loading-".concat(size);
    var variantClass = "lib-loading-".concat(variant);
    var inlineClass = inline ? "lib-loading-inline" : "";
    var allClasses = [baseClasses, sizeClass, variantClass, inlineClass, className].filter(Boolean).join(" ");
    var renderSpinner = function () { return React.createElement(FontAwesomeIcon, { icon: faSpinner, spin: true, className: "lib-loading-icon", style: { color: color } }); };
    var renderDots = function () { return (React.createElement("div", { className: "lib-loading-dots", style: { color: color } },
        React.createElement("span", { className: "lib-loading-dot" }),
        React.createElement("span", { className: "lib-loading-dot" }),
        React.createElement("span", { className: "lib-loading-dot" }))); };
    var renderPulse = function () { return React.createElement("div", { className: "lib-loading-pulse", style: { backgroundColor: color } }); };
    var renderLoader = function () {
        switch (variant) {
            case "dots":
                return renderDots();
            case "pulse":
                return renderPulse();
            case "spinner":
            default:
                return renderSpinner();
        }
    };
    return (React.createElement("div", { className: allClasses, role: "status", "aria-label": text || "Loading" },
        renderLoader(),
        text && React.createElement("span", { className: "lib-loading-text" }, text)));
};
export default Loading;
